export function getImageProperty({isMobile, cardData, property}) {
  return isMobile && cardData?.acf?.mobile_image?.[property]
    ? cardData?.acf?.mobile_image?.[property]
    : cardData?.acf?.desktop_image?.[property];
}
